export default __webpack_public_path__ + "static/img/southfork.0161919.jpg";